import React, { useState, useMemo, useEffect } from "react";
import "../scss/button.scss";
import "../scss/EnachMandate.scss";
// import { ReactComponent as WarningIcon } from "../images/warning-icon.svg";
import { ReactComponent as Enach } from "../images/enach.svg";
import { ReactComponent as Upi } from "../images/upi.svg";
import { ReactComponent as MoneyIn } from "../images/moneyin.svg";
import { ReactComponent as Calender } from "../images/calender.svg";
import { ReactComponent as NoMoney } from "../images/nomoney.svg";
import { ReactComponent as Shield } from "../images/shield-green.svg";
import { ReactComponent as GreenCheckIcon } from "../images/check-greeen.svg";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageHeader from "../components/PageHeader";
import { generateChecksum } from '../lib/middleware/generateChecksum';
import { setPageError, setIfscBankDetails } from "../lib/features/eligibilitySlice";

import { useSetUpAutopayMutation, useGetBankMandateMutation, useGetLoanbankDetailsMutation } from "../lib/services/eligibilityApi";
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";


import { useDispatch, useSelector, } from 'react-redux';
import { useTapClickMutation } from "../lib/middleware/TapClickApi";



function EnachMandate() {
  const location = useLocation()
  const [getLoanbankDetails] = useGetLoanbankDetailsMutation();
  const [tapClick] = useTapClickMutation()

  // const [checked, setChecked] = useState(false);
  const [isUpi, setIsUpi] = useState(false);
  const [setUpAutopay] = useSetUpAutopayMutation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
  const utmSource = useMemo(() => queryParams.get('utm_source'), [queryParams])
  const jwt = useMemo(() => queryParams.get("jwt_token"), [queryParams]);
  const secret = useMemo(() => queryParams.get("secret"), [queryParams]);
  const deviceid = useMemo(() => queryParams.get("device_id"), [queryParams]);
  const { partnerLocDetails, pageerror, ifscBankDetails } = useSelector(
      (state) => state.eligibility
  );


  const handleOpen = () => {
    setIsModalOpen(true);
  }

  let jwt_token
  if (jwt) {
    jwt_token = jwt
    localStorage.setItem('jwt', jwt)
  } else {
    jwt_token = localStorage.getItem('jwt')
  }
  const device_id = useMemo(() => queryParams.get('device_id'), [queryParams])
  const scrt = secret ? secret : localStorage.getItem('secret')

  const dummyAccount = "2345678904"

  const getEnach = () => {
    const url = `${process.env.REACT_APP_API_URL}/v2/api/?webdebug=nachs`;

    const headers = {
      "secret": scrt,
      "Content-Type": "application/x-www-form-urlencoded",
    };

    const body = {
      "mode": "get_customer_details",
      "pan_number": "ACXPM5858R"
    };
    const checksum = generateChecksum(body)

    fetch(url, {
      method: "POST",
      headers: headers,
      body: new URLSearchParams({ ...body, checksum }).toString()
    })
      .then(response => response.json())
      .then(data => {
        debugger;
        if (data.redirect_url) {
          window.location.href = data.redirect_url
        }
        else {
          setPageError(data.error)
        }
      })
      .catch(error => console.error("Error:", error));
  }

  const Setupautopay = async () => {
    pushCleverTapEvent({
      event_name: 'web_enach_start',
      event_property: {
        Source: utmSource,
        "mandate flow": "NACH",
        "mandate amount": "150000",
        vendor: "Digio",
        segment: localStorage.getItem('customerSegment'), 
      }
    })
    try {
      const requestData = {}
      let jwt_token
      if (jwt) {
        jwt_token = jwt
        localStorage.setItem('jwt', jwt)
      } else {
        jwt_token = localStorage.getItem('jwt')
      }
      const scrt = secret ? secret : localStorage.getItem('secret')
      //const result = await loanSummary({ ...requestData, jwt_token, scrt, device_id })
      const result = await setUpAutopay({ ...requestData, jwt_token, scrt, utmSource })
      if (result.data && result.data.status === 'error') {
        dispatch(setPageError(result.data.message))
        if (result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        }
        handleOpen()
      } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
        dispatch(setPageError(result.data.message))
        localStorage.removeItem('jwt');
        localStorage.removeItem('lastVisitedPage');
        const phone = localStorage.getItem('phone')
        localStorage.clear()
        phone ? navigate(`/?phone=${phone}`) : navigate('/');
        
      } else if (result.error) {
        dispatch(setPageError('Please check your internet or try again later.'))
        handleOpen()
      } else {
        window.location.href = result.data.redirect_url
      }
    } catch (error) {
      dispatch(setPageError('Something went wrong. Please try again later.'));
      handleOpen()
    }
  }
  const GetBankInfo = async () => {
    try {
      //const requestData = {};
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      //requestData.ifsc = "KKBK0005311";
      const scrt = secret ? secret : localStorage.getItem("secret");
      //const result = await getbankdetail({ ...requestData, jwt_token, scrt });
      const result = await getLoanbankDetails({ jwt_token, scrt, utmSource, deviceid });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        dispatch(
          setPageError(
            result?.error?.data?.error_message ||
            result?.error?.data?.message ||
            "Please check your internet or try again later."
          )
        );
        // handleErrorModalOpen();
      } else {
        dispatch(setIfscBankDetails(result.data));
        // setShowPopup(true);

        // window.location.href = result.data?.data.redirect_url
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      //   handleErrorModalOpen();
    }
  };
  useEffect(() => {
    GetBankInfo()
  }, [])

  useEffect(() => {
    if(ifscBankDetails) {
      pushCleverTapEvent({
        event_name: 'web_enach_open',
        event_property: {
          Source: utmSource,
          "bank name": ifscBankDetails?.bank_name,
          "account number": ifscBankDetails?.account_no.slice(-4),
          segment: localStorage.getItem('customerSegment') === "A3-A6" ? "Non-STP" : "STP", 
        }
      })
    }
    
    }, [ifscBankDetails])

  return (
    <div className="external-wrapper">
      <div className="page-content mandate-page">
        <PageHeader />
      </div>
      <div className="body">
        <h1 style={{ marginTop: 0 }}>
          {isUpi ? "UPI" : "eNACH"} auto-pay
          {isUpi ? <Upi /> : <Enach />}
        </h1>
        <div className="whybox">
          <div className="title">Why is this required?</div>
          <div className="subtitle">
            This step is only to authorize eNACH auto pay.
          </div>
          <div>
            <div>
              <NoMoney />
              <p>No money deduction now</p>
            </div>
            <div>
              <MoneyIn />
              <p>EMI debits only when due</p>
            </div>
            <div>
              <Calender />
              <p>Never miss a due date</p>
            </div>
          </div>
        </div>
        {ifscBankDetails &&
          <div className="box">
            <div className="detailsContainer">
              <p className="accountNumber">Account Number</p>  {/* {"customerBankDetails?.ifsc_code"} */}
              <div>
                <span>XXXX XXXX {ifscBankDetails.account_no.slice(-4)}</span>
                <GreenCheckIcon className="greenIcon" />
              </div>
            </div>
            <div className="divider" />
            <div className="detailsContainer">
              <p className="accountNumber">Bank Name</p>  {/* {"customerBankDetails?.ifsc_code"} */}
              <div>
                <span>{ifscBankDetails.bank_name}</span> {/* {"customerBankDetails?.account_number"} */}
                <GreenCheckIcon />
              </div>
            </div>
          </div>
        }
        <div className="setupmandate">
          Set up mandate to get funds
        </div>
        <div className="moneyDeduction">
          Do not worry, there is no money deduction
        </div>
        <div className="datasafety">
          <Shield /> 100% safe & secure
        </div>
        <div className="bottom-footer">
          <p className="powered-by">
            {" "}
            Powered by <StarfinLogo />{" "}
          </p>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={() => {
              Setupautopay();
            }}
          >
            {" "}
            Continue{" "}
          </button>
        </div>
        {/* <p className="powered-by">
            Powered by &nbsp; <StarfinLogo />
          </p>
          <button className={`btn btn-primary`} onClick={() => {}}>
            Continue
          </button> */}
      </div>
    </div>
  );
}

export default EnachMandate;
